<template>  
    <div class="channel-box">
        <div class="channel-box-bg">
            <el-row class="channel-box-title">
                <el-row class="channel-box-item">
                    <div class="channel-box-circle"></div>
                    <h2>强基计划</h2>
                    <div class="channel-box-one">1 TO 1</div>
                </el-row>
                <el-row class="channel-box-item1">
                    <div class="channel-box-circle"></div>
                    <h2>一对一填报服务</h2>
                </el-row>
            </el-row>
        </div>
        <el-row class="channel-box-desc">
            <el-row class="channel-box-infor">
                <div class="common-title">
                    <h3>什么是强基计划</h3>
                </div>
                <div class="channel-infor-js">
                    <el-row class="channel-infor-js-item">
                        <el-row>
                            <el-col :span="1" style="width: 2%">
                            <div class="channel-infor-circle">
                                <span></span>
                            </div>
                            </el-col>
                            <el-col :span="23">选拔培养有志于服务国家重大战略需求且综合素质优秀或基础学科拔尖的学生。</el-col>
                        </el-row>
                    </el-row>
                    <el-row class="channel-infor-js-item">
                        <el-row>
                            <el-col :span="1" style="width: 2%">
                            <div class="channel-infor-circle">
                                <span></span>
                            </div>
                            </el-col>
                            <el-col :span="23">可填报专业：数学、物理、化学、生物、历史、哲学、古文字学等。</el-col>
                        </el-row>
                    </el-row>
                    <el-row class="channel-infor-js-item">
                        <el-row>
                            <el-col :span="1" style="width: 2%">
                            <div class="channel-infor-circle">
                                <span></span>
                            </div>
                            </el-col>
                            <el-col :span="23">聚集高端芯片与软件、智能科技、新材料、先进制造和国家安全等关键领域以及国家人才紧缺的人文 社会科学领域。高校会结合自身办学特色，安排招生专业，并建立学科专业的动态调整机制。</el-col>
                        </el-row>
                    </el-row>
                </div>
            </el-row>
            <el-row class="channel-box-infor channel-box-infor-diff1">
                <div class="common-title">
                    <h3>适合哪些学生</h3>
                </div>
                <el-row type="flex" justify="space-between" class="channel-box-student">
                    <el-col :span="12" :style="'background-image: url('+item.src+');'" v-for="(item,index) in studentsBgList" :key="index">
                        <div v-html="item.desc"></div>
                    </el-col>
                </el-row>
            </el-row>
            <el-row class="channel-box-infor channel-box-infor-diff1 channel-box-infor-diff3">
                <div class="common-title">
                    <h3>为何要填报强基计划</h3>
                </div>
                    <el-row class="channel-box-reason">
                    <img src="../../assets/images/channel-reason.png">
                    <el-row>
                        <el-col :span="1">
                            <div class="channel-box-reason-circle">1</div>
                        </el-col>
                        <el-col :span="23">
                            给了普通学生更多的机会，只要高考成绩在一本线以上，则有机会入选校考，可获得高校的一定降分，捡漏机会大。
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="1">
                            <div class="channel-box-reason-circle">2</div>
                        </el-col>
                        <el-col :span="23">
                            强基计划聚焦高端芯片与软件、智能科技、新材料、先进制造、国家安全领域、国家人才紧缺的人文社会科学领域，都是未来的国家发展的热点领域，是未来的热门岗位。
                        </el-col>
                    </el-row>
                </el-row>
            </el-row>
            <el-row style="background: #fff5f0;">
                <el-row class="channel-box-infor channel-box-infor-diff2">
                    <div class="common-title">
                        <h3>录取方式</h3>
                    </div>
                    <el-row class="channel-box-way">
                        <el-row class="channel-box-way-title">
                            <span class="channel-box-way-title-bg2"></span>
                            <span class="channel-box-way-title-bg1"></span>
                            <h4>录取方式1</h4>
                        </el-row>
                        <el-row class="channel-box-way-desc">
                            <span>综合成绩录取：</span>
                            高校将考生的高考成绩、高校综合考核结果、综合素质评价情况等折合成综合成绩，由高到低顺序录取，体现对学生更加全面综合地评价。其中，高考成绩的占比不得低于85%。
                        </el-row>
                    </el-row>
                    <el-row class="channel-box-way">
                        <el-row class="channel-box-way-title">
                            <span class="channel-box-way-title-bg2"></span>
                            <span class="channel-box-way-title-bg1"></span>
                            <h4>录取方式2</h4>
                        </el-row>
                        <el-row class="channel-box-way-desc">
                            <span>破格录取：</span>
                            由高校提前制订破格入围高校考核的田间和破格录取的办法、标准，并向社会公布，组织专家对相关考生进行严格考核，达到录取标准的，经高校招生工作领导小组审定，报经生源所在地省级高校招生委员会核准后予以录取。
                        </el-row>
                    </el-row>
                </el-row>
            </el-row>
            <el-row class="channel-box-tips-bg">
                <el-row class="channel-box-infor channel-box-infor-diff1">
                    <div class="common-title">
                        <h3 style="color:#ffffff">招生流程</h3>
                    </div>
                    <el-row class="channel-box-tips-line"></el-row>
                    <el-row class="channel-box-tips" type="flex">
                        <div class="channel-box-tips-item-common1">
                            <span class="channel-box-tips-circle"></span>
                            <div class="channel-box-tips-line1"></div>
                            <div class="channel-box-tips-content">
                                <span>3月底前</span><br>
                                高校公布招生简章
                            </div>
                        </div>
                        <div class="channel-box-tips-item2 channel-box-tips-item-common1 channel-box-tips-item-common">
                            <div class="channel-box-tips-content">
                                <span>4月</span><br>
                                考生网上报名
                            </div>
                            <div class="channel-box-tips-line1"></div>
                            <span class="channel-box-tips-circle"></span>
                        </div>
                        <div class="channel-box-tips-item3 channel-box-tips-item-common1">
                            <span class="channel-box-tips-circle"></span>
                            <div class="channel-box-tips-line1"></div>
                            <div class="channel-box-tips-content">
                                <span>6月</span><br>
                                考生参加统一高考
                            </div>
                        </div>
                        <div class="channel-box-tips-item4 channel-box-tips-item-common1 channel-box-tips-item-common">
                            <div class="channel-box-tips-content">
                                <span>6月25日前</span><br>
                                提供高考成绩
                            </div>
                            <div class="channel-box-tips-line1"></div>
                            <span class="channel-box-tips-circle"></span>
                        </div>
                        <div class="channel-box-tips-item5 channel-box-tips-item-common1">
                            <span class="channel-box-tips-circle"></span>
                            <div class="channel-box-tips-line1"></div>
                            <div class="channel-box-tips-content">
                                <span>6月26日前</span><br>
                                高校确定入围学校<br>考核考生名单
                            </div>
                        </div>
                        <div class="channel-box-tips-item6 channel-box-tips-item-common1 channel-box-tips-item-common">
                            <div class="channel-box-tips-content">
                                <span>7月4日前</span><br>
                                高校组织考核
                            </div>
                            <div class="channel-box-tips-line1"></div>
                            <span class="channel-box-tips-circle"></span>
                        </div>
                        <div class="channel-box-tips-item7 channel-box-tips-item-common1">
                            <span class="channel-box-tips-circle"></span>
                            <div class="channel-box-tips-line1"></div>
                            <div class="channel-box-tips-content">
                                <span>7月5日前</span><br>
                                高校根据分数核算<br>方法择优录取
                            </div>
                        </div>
                    </el-row>
                </el-row>
            </el-row>
            <el-row style="background: #fff5f0;">
                <el-row class="channel-box-infor channel-box-point channel-box-infor-diff1">
                    <div class="common-title">
                        <h3>填报难点</h3>
                    </div>
                    <img src="../../assets/images/channel-point.png">
                    <el-row class="channel-box-point-list">
                        <el-row class="channel-box-point-item-common">
                            <el-col>看不懂强基计划政策</el-col>
                            <el-col>不知道可以报考哪些学校</el-col>
                        </el-row>
                        <el-row class="channel-box-point-item-common channel-box-point-item-common-diff1">
                            <el-col>不知道可以填报什么专业</el-col>
                            <el-col>不知道该做哪些准备</el-col>
                        </el-row>
                        <el-row class="channel-box-point-item-common">
                            <el-col>不知道个人陈述怎么写</el-col>
                            <el-col>不知道报考流程是什么</el-col>
                        </el-row>
                    </el-row>
                </el-row>
            </el-row>
            <el-row class="channel-box-service-bg">
                <el-row class="channel-box-infor channel-box-infor-diff1">
                    <div class="common-title">
                        <h3 style="color:#fff">服务流程</h3>
                    </div>
                    <el-row type="flex" justify="space-between" class="channel-box-service">
                        <el-col v-for="(item,index) in serviceList" :key="index">
                            <el-row class="channel-box-service-title">
                                <span class="channel-box-service-title-bg2"></span>
                                <h4>{{item.step}}</h4>
                            </el-row>
                            <el-row class="channel-box-service-item">
                                <img :src="item.src">
                                <h4>{{item.title}}</h4>
                                <p>{{item.desc}}</p>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-row>
            </el-row>
            <el-row class="channel-box-good-bg">
                <el-row class="channel-box-infor channel-box-infor-diff2 channel-box-infor-diff4">
                    <div class="common-title">
                        <h3>服务优势</h3>
                    </div>
                    <el-row style="clear:both"></el-row>
                    <el-row class="channel-box-good-item">
                        <img src="../../assets/images/good-icon1.png">
                        团队优势
                        <p>荔枝新高考顶级专家团队全程跟踪,一对一线上线下规划指导</p>
                    </el-row>
                    <el-row class="channel-box-good-item">
                        <img src="../../assets/images/good-icon2.png">
                        流程优势
                        <p>一站式服务、自我评估、目标定位、院校选择多重指导等</p>
                    </el-row>
                    <el-row class="channel-box-good-item">
                        <img src="../../assets/images/good-icon3.png">
                        品牌优势
                        <p>可靠的品牌支撑，实力、可信、靠谱</p>
                    </el-row>
                </el-row>
                <el-row class="channel-box-infor channel-box-order">
                    <img src="../../assets/images/channel-order.png" alt="">
                    <div>
                        <span class="channel-box-order-title">预约专家 免费咨询</span>
                        <span class="channel-box-order-desc">留下联系方式，立即与专家一对一</span>
                    </div>
                    <el-row>
                        <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                            <el-form-item label="姓名：" prop="username">
                                <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                            </el-form-item>
                            <el-form-item label="电话：" prop="phone">
                                <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                            </el-form-item>
                        </el-form>
                    </el-row>
                </el-row>
            </el-row>
        </el-row>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        return {
            studentsBgList:[
                {src:require('../../assets/images/channel-student1.jpg'),desc:'高考成绩优异的学生'},
                {src:require('../../assets/images/channel-student2.jpg'),desc:'少数在某个学科领域</br>具有突出才能的人才'},
            ],
            serviceList: [
                {src:require('../../assets/images/channel-step1.png'),desc:'根据学生职业测评结果、报考意向，帮助学生确定适合报考学校和专业',step:'第一步',title:'确定学校和专业'},
                {src:require('../../assets/images/channel-step2.png'),desc:'一对一讲解服务，引导学生及家长了解强基计划的招生、录取特点和具体要求',step:'第二步',title:'一对一讲解'},
                {src:require('../../assets/images/channel-step3.png'),desc:'指导学生撰写符合目标院校要求的个人陈述，并进行最终润色',step:'第三步',title:'撰写个人陈述'},
                {src:require('../../assets/images/channel-step4.png'),desc:'指导学生完成网上报名，整理相关证明材料，助力学生脱颖而出',step:'第四步',title:'完成网上报名'},
            ],
            formInline: {
                username: '',
                phone: '',
                type: '8'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
            }
        };
    },
    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    @font-face {
        font-family: 'zihun443hao';
        src: url('../../assets/fonts/zihun443hao.ttf');
    }
    $width: 1200px;
    $margin: 0 auto;
    $font-family: 'zihun443hao';
    .channel-box-bg {
        background: url('../../assets/images/channel-bg.png') no-repeat;
        background-size: cover;
        width: 100%;
        height: 668px;
        background-position: center;
        .channel-box-title {
            width: $width;
            margin: $margin;
            padding: 96px 0;
            position: relative;
            left: -10px;
            .channel-box-item {
                @include gflex;
                position: relative;
            }
            .channel-box-circle {
                width: 88px;
                height: 88px;
                background: rgba(255,255,255,0.40);
                border-radius: 50%;
                box-shadow: 0px 6px 20px 0px rgba(255,101,36,0.14), 0px 1px 0px 0px rgba(255,255,255,0.50) inset; 
                backdrop-filter: blur(2px);
                position: absolute;
                top: 72px;
                left: -62px;
            }
            h2 {
                font-family: $font-family;
                color: $common-color;
                font-weight: 400!important;
                font-size: 88px!important;
                margin: 0;
            }
            .channel-box-one {
                font-size: 24px;
                color: #ffffff;
                font-weight: 400;
                font-family: $font-family;
                width: 100px;
                height: 39px;
                line-height: 39px;
                background: #fe9f0a;
                border-radius: 20px 20px 20px 2px;
                text-align: center;
                margin-left: 18px;
                margin-top: 44px;
            }
        }
        .channel-box-item1 {
            margin-top: 26px;
            .channel-box-circle {
                width: 59px;
                height: 59px;
                background: linear-gradient(153deg,rgba(255,158,74,0.40) 9%, rgba(255,101,36,0.40) 92%);
                border-radius: 50%;
                box-shadow: 3px 6px 20px 0px rgba(255,101,36,0.20), 1px 1px 0px 0px rgba(255,255,255,0.49) inset; 
                backdrop-filter: blur(2px);
                position: absolute;
                top: 74px;
                left: 526px;
            }
            h2 {
                font-family: $font-family;
                color: #332e2c;
                font-weight: 400!important;
                font-size: 88px;
                margin: 0;
            }
        }
    }
    .channel-box-infor {
        width: $width;
        margin: $margin;
        h3 {
            font-size: 36px;
            font-family: $font-family;
            font-weight: 400;
            color: #332e2c;
            padding-bottom: 10px;
            box-shadow: 0 -28px 0 0 #ffc05e inset;
            margin: 0 auto;
            letter-spacing: 4.5px!important;
            text-align: center;
            margin-bottom: 48px;
            // span {
            //     display: inline-block;
            // }
            // span:not(:last-child) {
            //     margin-right: 4px;
            // }
        }
        .channel-infor-js {
            height: 313px;
            background: rgba(255,255,255,0.80);
            border-radius: 20px;
            box-shadow: 0px 4px 20px 0px rgba(143,43,0,0.12), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
            backdrop-filter: blur(4px);
            box-sizing: border-box;
            padding: 50px 40px;
            margin-top: 48px;
            .channel-infor-js-item:not(:last-child) {
                border-left: 1px dashed $common-color;
                height: 67px;
            }
            .channel-infor-circle {
                width: 22px;
                height: 22px;
                background: #ffe8de;
                border-radius: 50%;
                position: relative;
                left: -11px;
            span {
                display: inline-block;
                width: 10px;
                height: 10px;
                background: $common-color;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            }
            .el-col-23 {
                color: #332e33;
                font-weight: 400;
                font-size: 24px;
                line-height: 40px;
                position: relative;
                top: -10px;
                padding-left: 10px;
            }
        }
    }
    .channel-box-desc {
        margin-top: -200px;
    }
    .channel-box-infor-diff1 {
        margin-top: 62px;
    }
    .channel-box-infor-diff2 {
        margin-top: 75px;
        h3 {
            margin-bottom: 86px;
        }
    }
    .channel-box-infor-diff3 {
        margin-bottom: 75px;
    }
    .channel-box-student {
        padding: 0 36px;
        .el-col-12 {
            width: 524px;
            height: 226px;
            position: relative;
            div {
                width: 288px;
                height: 125px;
                background: rgba(255,255,255,0.80);
                border: 1px solid #ffffff;
                border-radius: 20px;
                box-shadow: 0px 5px 12px 0px rgba(255,110,48,0.16); 
                backdrop-filter: blur(4px);
                font-size: 26px;
                color: $common-color;
                font-family: $font-family;
                @include gflex;
                justify-content: center;
                align-items: center;
                position: absolute;
                right: -12px;
                bottom: -12px;
            }
        }
    }
    .channel-box-reason {
        @include gwidth;
        width: 1200px;
        background: linear-gradient(180deg,#ff9e4a, $common-color);
        border-radius: 20px;
        box-shadow: 0px 8px 30px 0px rgba(255,97,26,0.38);
        height: 281px;
        padding: 37px 43px;
        box-sizing: border-box;
        img {
            position: absolute;
            top: 0;
            left: 0;
        }
        .channel-box-reason-circle {
            width: 38px;
            height: 38px;
            background: rgba(255,255,255,0.90);
            border-radius: 50%;
            font-size: 24px;
            color: $common-color;
            font-family: $font-family;
            line-height: 38px;
            text-align: center;
        }
        .el-col-23 {
            font-size: 24px;
            color: #ffffff;
            line-height: 40px;
            padding-left: 10px;
            position: relative;
            top: -6px;
            margin-bottom: 32px;
        }
    }
    .channel-box-way {
        position: relative;
        margin-bottom: 80px;
        .channel-box-way-title {
            position: absolute;
            z-index: 99;
            top: -32px;
            left: 30px;
            .channel-box-way-title-bg2 {
                transform: skew(-10deg);
                -webkit-transform: skew(-10deg);
                -moz-transform: skew(-10deg);
                -o-transform: skew(-10deg);
                -ms-transform: skew(-10deg);
                width: 166px;
                height: 65px;
                background: #ffd624;
                border-radius: 8px;
                position: absolute;
                left: 6px;
                top: 6px;
            }
            .channel-box-way-title-bg1 {
                transform: skew(-10deg);
                -webkit-transform: skew(-10deg);
                -moz-transform: skew(-10deg);
                -o-transform: skew(-10deg);
                -ms-transform: skew(-10deg);
                width: 166px;
                height: 65px;
                background: $common-color;
                border-radius: 8px;
                position: absolute;
                left: 0;
                top: 0;
            }
            h4 {
                font-size: 26px;
                color: #ffffff;
                font-family: $font-family;
                margin: 0;
                padding: 0;    
                position: relative;
                z-index: 99;
                padding: 0 26px;
                line-height: 65px;
                font-weight: 400;
            }
        }
        .channel-box-way-desc {
            background: #ffffff;
            border-radius: 20px;
            box-shadow: 0px 4px 16px 0px rgba(131,41,0,0.17); 
            padding: 61px 40px 45px 40px;
            color: #332e2c;
            font-size: 24px;
            font-weight: 600;
            line-height: 40px;
            span {
                color: $common-color;
            }
        }
    }
    .channel-box-tips-bg {
        background: url('../../assets/images/channel-tips.jpg') no-repeat;
        background-size: cover;
        background-position: center;
        height: 600px;
        padding: 0 18px;
        box-sizing: border-box;
        position: relative;
        .channel-box-tips-line {
            background: url('../../assets/images/tips-border.png') no-repeat;
            background-size: cover;
            background-position: center;
            width: 100%;
            height: 1px;
            position: relative;
            top: 180px;
        }
        .channel-box-tips {
            position: relative;
            top: 170px;
            .channel-box-tips-circle {
                display: inline-block;
                width: 17px;
                height: 17px;
                background: #ffffff;
                border-radius: 50%;
                box-shadow: 0px 0px 6px 0px rgba(255,255,255,0.50); 
            }
            .channel-box-tips-line1 {
                width: 2px;
                height: 40px;
                opacity: 0.6;
                border-left: 1px dashed #ffffff;
            }
            .channel-box-tips-item-common1 {
                margin-left: 20px;
                .channel-box-tips-circle {
                    position: relative;
                    left: 86px;
                }
                .channel-box-tips-line1 {
                    position: relative;
                    left: 94px;
                }
            }
            .channel-box-tips-item2 {
                margin-left: -5px;
            }
            .channel-box-tips-item3 {
                margin-left: 20px;
            }
            .channel-box-tips-item4 {
                margin-left: 10px;
            }
            .channel-box-tips-item5 {
                margin-left: -120px;
            }
            .channel-box-tips-item6 {
                margin-left: -20px;
            }
            .channel-box-tips-item7 {
                margin-left: -100px;
            }
            .channel-box-tips-item-common {
                position: relative;
                top: -142px;
            }
            .channel-box-tips-content {
                width: 198px;
                min-height: 99px;
                background: rgba(255,255,255,0.86);
                border-image: linear-gradient(180deg, #ffffff, rgba(255,255,255,0.48) 99%) 1 1;
                border-radius: 8px;
                box-shadow: 0px 4px 16px 0px rgba(131,41,0,0.17); 
                backdrop-filter: blur(4px);
                color: #2c2e33;
                font-weight: 500;
                font-size: 19px;
                padding: 14px 16px;
                box-sizing: border-box;
                line-height: 32px;
                span {
                    display: inline-block;
                    color: $common-color;
                    font-family: $font-family;
                    font-weight: 800;
                    margin-bottom: 10px;
                    font-size: 26px;
                }
            }
        }
    }
    .channel-box-point {
        position: relative;
        h3 {
            margin: 0 auto;
            padding: 0;
            padding-bottom: 10px;
        }
        img {
            margin-top: 14px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            width: 662px;
            height: 662px;
        }
        .channel-box-point-list {
            position: relative;
            top: 50px;
        }
        .channel-box-point-item-common:not(:last-child) {
            margin-bottom: 167px;
        }
        .channel-box-point-item-common:last-child {
            margin-bottom: 150px;
        }
        .channel-box-point-item-common {
            position: relative;
            left: 64.8%;
            transform: translateX(-50%);
            .el-col {
                width: 350px;
                height: 80px;
                background: linear-gradient(180deg,#ff8b3b, $common-color);
                border-radius: 20px;
                text-align: center;
                color: #ffffff;
                line-height: 80px;
                font-size: 26px;
            }
            .el-col:first-child {
                margin-right: 72px;
            }
            .el-col:last-child {
                margin-left: 72px;
            }
        }
        .channel-box-point-item-common-diff1 {
            .el-col:first-child {
                position: relative;
                left: -195px;
            }
            .el-col:last-child {
                position: relative;
                right: -195px;
            }
        }
    }
    .channel-box-service-bg {
        background: url('../../assets/images/channel-service.jpg') no-repeat;
        background-position: center;
        background-size: cover;
        height: 686px;
        .channel-box-service {
            margin-top: 90px;
            position: relative;
            .el-col {
                width: 268px;
                height: 380px;
                opacity: 0.9;
                background: rgba($color: #ffffff, $alpha: 0.9);
                border-radius: 20px;
                box-shadow: 0px 4px 16px 0px rgba(131,41,0,0.17); 
                backdrop-filter: blur(15px);
                padding: 32px;
                box-sizing: border-box;
                text-align: center;
            }
            .channel-box-service-title {
                position: absolute;
                z-index: 99;
                top: -32px;
                left: 30px;
                .channel-box-service-title-bg2 {
                    transform: skew(-10deg);
                    -webkit-transform: skew(-10deg);
                    -moz-transform: skew(-10deg);
                    -o-transform: skew(-10deg);
                    -ms-transform: skew(-10deg);
                    width: 166px;
                    height: 65px;
                    background: #ff8e32;
                    border-radius: 8px;
                    position: absolute;
                    left: 20px;
                    top: 0px;
                }
                h4 {
                    font-size: 26px;
                    color: #ffffff;
                    font-family: $font-family;
                    margin: 0;
                    padding: 0;    
                    position: relative;
                    z-index: 99;
                    padding: 0 26px 0 68px;
                    line-height: 65px;
                    font-weight: 400;
                }
            }
            .channel-box-service-item {
                img {
                    width: 86px;
                    height: 86px;
                    margin-top: 22px;
                }
                h4 {
                    font-size: 26px;
                    font-family: $font-family;
                    color: #332e2c;
                    font-weight: 400;
                    margin-top: 17px;
                    margin-bottom: 17px;
                }
                p {
                    font-size: 20px;
                    font-weight: 400;
                    color: #66605e;
                    line-height: 32px;
                    text-align: left;
                }
            }
        }
    }
    .channel-box-infor-diff4 {
        padding-left: 580px;
        h3 {
            float: left;
            margin-bottom: 60px;
        }
    }
    .channel-box-good-bg {
        background: url('../../assets/images/channel-good.jpg') no-repeat;
        background-position: center;
        background-size: cover;
        height: 1176px;
        margin-bottom: -56px;
        .channel-box-good-item {
            font-size: 30px;
            font-family: $font-family;
            color: $common-color;
            margin-bottom: 59px;
            img {
                width: 30px;
                height: 30px;
                position: relative;
                top: 6px;
            }
            p {
                font-size: 24px;
                color: #332e2c;
                margin-top: 23px;
                line-height: 43px;
                font-weight: 400;
                margin-bottom: 0;
            }
        }
    }
    .channel-box-order {
        @include gwidth;
        width: 1200px;
        height: 255px;
        background: linear-gradient(180deg,#ff9e4a, $common-color);
        border-radius: 20px;
        box-shadow: 0px 8px 30px 0px rgba(255,97,26,0.38);
        padding: 48px;
        margin-top: 170px;
        position: relative;
        span {
            display: inline-block;
        }
        img {
            position: absolute;
            top:0;
            left: 0;
        }
        .channel-box-order-title {
            font-size: 36px;
            font-family: $font-family;
            color: #ffffff;
        }
        .channel-box-order-desc {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
            margin-left: 24px;
        }
    }
    .common-title {
        text-align: center;
        h3 {
            display: inline-block;
        }
    }
</style>